import { Alert, AlertColor, AlertTitle, Stack } from "@mui/material";
import React, { useState } from "react";
import { getMessage } from "../../redux/services/message";

type Props = {
  severity: AlertColor;
  messageType: string;
};

const MuiAlert = (props: Props) => {
  return (
    <div>
      {props.messageType && (
        <Stack>
          <Alert
            variant="filled"
            severity={props.severity}
            className="text-[20spx]"
          >
            {getMessage[props.messageType] || props.messageType}
          </Alert>
        </Stack>
      )}
    </div>
  );
};

export default MuiAlert;
